const getMatchingApiUrl = () => {
  if (process.env.REACT_APP_PANCHANGAM_API_URL) return process.env.REACT_APP_PANCHANGAM_API_URL;
  if (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')) {
    return 'http://localhost:8082';
  }
  return 'https://brahminsnet.com:8082';
};

export async function matchHoroscopeViaAPI(boyDetails, girlDetails, lang) {
  const apiUrl = getMatchingApiUrl();
  const res = await fetch(`${apiUrl}/v1/matchHoroscope`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ boy: boyDetails, girl: girlDetails, lang: lang === 'en' ? 'en' : 'ta' }),
    signal: AbortSignal.timeout(20000),
  });
  if (!res.ok) throw new Error('matchHoroscope API HTTP ' + res.status);
  const d = await res.json();
  if (!d || !d.success || !d.result) throw new Error('matchHoroscope API returned no result');
  return d.result;
}
